import type { SyntheticEvent } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import { type TransportOption } from 'tripPlanner/api/types'
import { formatTransportAlternativeLabel } from '../utils/formatTransportDuration'

interface Props {
  option: TransportOption
  disabled: boolean
  onSelect: (itemId: number) => void
}

function TransportAlternativeLink({ option, disabled, onSelect }: Props) {
  const intl = useIntl()
  const handleClick = useCallback((event: SyntheticEvent) => {
    event.stopPropagation()
    if (disabled) return
    onSelect(option.itemId)
  }, [disabled, onSelect, option.itemId])

  return (
    <TextLink size="caption" disabled={disabled} onClick={handleClick}>
      {formatTransportAlternativeLabel(option, intl)}
    </TextLink>
  )
}

export default TransportAlternativeLink
